import { render, staticRenderFns } from "./FeaturedContentBuilder.vue?vue&type=template&id=70456260&scoped=true&"
import script from "./FeaturedContentBuilder.vue?vue&type=script&lang=js&"
export * from "./FeaturedContentBuilder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70456260",
  null
  
)

export default component.exports